// This reducer is to hold unchanging "constants" - they might be set dynamically on load but don't change after that
//
// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/settings/';
export const actions = [
  'SET_ENV',
  'SET_APP_VERSION',
  'SET_IS_APP_MODE',
  'SET_IS_FULL_SCREEN',
  'SET_IS_MOBILE',
  'SET_CAME_FROM_SUBFIELD_N',
  'SET_REFERRER',
  'SET_HAS_DONE_FIRST_LOAD',
  'SET_AUTH_CLIENT',
  'SET_ENTRY_PATH',
  'SET_PRODUCT_YEARS',
  'SET_DEFAULT_SCRIPT_TYPE',
  'SET_ROUTE_VERSION'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducers

const commonOptions = {
  metric: false,
  shapeOptions: {
    opacity: 0.8,
    fillOpacity: 0.35
  }
};

export default function reducer ( // NOSONAR False-Positive, Reducer Exception
  state = {
    toolBarOptions: {
      polygon: commonOptions, // If we ever change these, consider if you want them to all be the same object or copies
      rectangle: commonOptions,
      circle: commonOptions
    },
    isAppMode: false,
    appVersion: '',
    cameFromSubfieldN: false,
    productYears: {}
  },
  action = {}
) {
  switch (action.type) {
    case actions.SET_ENV:
      return {...state, env: action.payload.env};
    case actions.SET_IS_APP_MODE:
      return {...state, isAppMode: action.payload.isAppMode};
    case actions.SET_APP_VERSION:
      return {...state, appVersion: action.payload.appVersion};
    case actions.SET_IS_FULL_SCREEN:
      return {...state, isFullScreen: action.payload.isFullScreen};
    case actions.SET_IS_MOBILE:
      return {...state, isAppMode: action.payload.isAppMode};
    case actions.SET_CAME_FROM_SUBFIELD_N:
      return {...state, cameFromSubfieldN: action.payload.cameFromSubfieldN};
    case actions.SET_REFERRER:
      return {...state, referrer: action.payload.referrer};
    case actions.SET_HAS_DONE_FIRST_LOAD:
      return {...state, hasDoneFirstLoad: action.payload.hasDoneFirstLoad};
    case actions.SET_AUTH_CLIENT:
      return {...state, authClient: action.payload.authClient};
    case actions.SET_ENTRY_PATH:
      return {...state, entryPath: action.payload.entryPath};
    case actions.SET_PRODUCT_YEARS:
      return {...state, productYears: action.payload.productYears};
    case actions.SET_DEFAULT_SCRIPT_TYPE:
      return {...state, defaultScriptType: action.payload.defaultScriptType};
    case actions.SET_ROUTE_VERSION:
      return {...state, routeVersion: action.payload.routeVersion};
    default:
      return state;
  }
}


// Action Creators

export const setEnv = (env) => ({
  type: actions.SET_ENV,
  payload: { env }
});

export const setIsAppMode = (isAppMode) => ({
  type: actions.SET_IS_APP_MODE,
  payload: { isAppMode }
});

export const setAppVersion = (appVersion) => ({
  type: actions.SET_APP_VERSION,
  payload: { appVersion }
});

// TODO - It seems like the code below should move into the reducer.
// I fixed calling code that was relying on it to execute in the creator.
// Counterpoint - I don't think anything that does more than alter state should be in the reducer
export const setIsFullScreen = (isFullScreen) => {

  const body = document.querySelector('body');
  const fullScreenStatusClass = 'isFullScreen';

  body.classList.remove(fullScreenStatusClass);
  if (isFullScreen) {
    body.classList.add(fullScreenStatusClass);
  }

  return {
    type: actions.SET_IS_FULL_SCREEN,
    payload: { isFullScreen }
  };
};

export const setisAppMode = (isAppMode) => {
  return {
    type: actions.SET_IS_MOBILE,
    payload: { isAppMode }
  };
};

export const setCameFromSubfieldN = (cameFromSubfieldN) => {
  return {
    type: actions.SET_CAME_FROM_SUBFIELD_N,
    payload: { cameFromSubfieldN }
  };
};

export const setReferrer = (referrer) => {
  return {
    type: actions.SET_REFERRER,
    payload: { referrer }
  };
};

export const setHasDoneFirstLoad = (hasDoneFirstLoad) => {
  return {
    type: actions.SET_HAS_DONE_FIRST_LOAD,
    payload: { hasDoneFirstLoad }
  };
};

export const setAuthClient = (authClient) => {
  return {
    type: actions.SET_AUTH_CLIENT,
    payload: { authClient }
  };
};

export const setEntryPath = (entryPath) => {
  return {
    type: actions.SET_ENTRY_PATH,
    payload: { entryPath }
  };
};

export const setProductYears = (productYears) => {
  return {
    type: actions.SET_PRODUCT_YEARS,
    payload: { productYears }
  };
};

export const setDefaultScriptType = (defaultScriptType) => {
  return {
    type: actions.SET_DEFAULT_SCRIPT_TYPE,
    payload: { defaultScriptType }
  };
};

export const setRouteVersion = (routeVersion) => {
  return {
    type: actions.SET_ROUTE_VERSION,
    payload: { routeVersion }
  };
};
